import * as API from '../data/dashboard_api';
import {signOutAction} from "./auth_actions";

export const GET_DASHBOARD_STATS = 'get_dashboard_display_data';
export const GET_CLERK_DASHBOARD_STATS = 'get_clerk_dashboard_display_data';
export const GET_PROVISIONAL_OFFER_STATS = 'get_provisional_offer_display_data';
export const GET_LAST_INSPECTIONS = "get_last_inspections"
export const CLEAR_DATA = 'refresh_data';
export const GET_CUSTOMER_SERVICE_LIST_BY_DATE = 'get_customer_service_list_by_date';
export const GET_PROPERTY_VISIT_LIST_BY_DATE = 'get_property_visit_list_by_date';

export function getDashboardData(startDate, endDate) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getDashboardData(startDate, endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_DASHBOARD_STATS, payload: response});
        }
    }
}

export function getClerkDashboardData(startDate, endDate) {
    return async (dispatch) => {
        // dispatch({type:CLEAR_DATA});
        const response = await API.getClerkStatisticsData(startDate, endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_CLERK_DASHBOARD_STATS, payload: response});
        }
    }
}

export function getProvisionalOfferData() {
    return async (dispatch) => {
        const response = await API.getProvisionalOfferData();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_PROVISIONAL_OFFER_STATS, payload: response});
        }
    }
}

export function getLastInspectionData() {
    return async (dispatch) => {
        const response = await API.getLastInspectionData();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_LAST_INSPECTIONS, payload: response});
        }
    }
}

export function getCustomerServiceByDate(URL, startDate, endDate) {
    return async (dispatch) => {
        //dispatch({type:CLEAR_DATA});
        const response = await API.getCustomerServiceByDate(URL, startDate, endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_CUSTOMER_SERVICE_LIST_BY_DATE, payload: response});
        }
    };
}

export function getPropertyVisitsByDate(URL, startDate, endDate) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getPropertyVisitsByDate(URL, startDate, endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_PROPERTY_VISIT_LIST_BY_DATE, payload: response});
        }
    };
}
export function getPropertyVisitsByAddress(URL, address) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getPropertyVisitsByAddress(URL, address);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_PROPERTY_VISIT_LIST_BY_DATE, payload: response});
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/dashboard_action.js